export default "__VITE_ASSET__B9797nwI__"